import { useTranslation } from 'react-i18next';
import type { MetaFunction } from 'react-router';
import Features from '~/components/main/Features';
import Footer from '~/components/main/Footer';
import Header from '~/components/main/Header';
import Intro from '~/components/main/Intro';
import MoreThanAnAgency from '~/components/main/MoreThanAnAgency';
import Pricing from '~/components/main/Pricing';
import { Separator } from '~/components/ui/separator';

export const meta: MetaFunction = () => {
  const { t } = useTranslation();
  return [{ title: 'GoPartner' }, { name: 'description', content: t('metaDescription') }];
};

export default function Index() {
  return (
    <div className="relative flex min-h-screen flex-col">
      <Header />
      <main className="container mx-auto flex-1 flex flex-col justify-center items-center">
        <Intro />
        <Separator className="my-12" />
        <Features />
        <Separator className="my-12" />
        <Separator className="my-12" />
        <Pricing />
        <MoreThanAnAgency />
      </main>
      <Footer />
    </div>
  );
}
